import React from 'react';

const SecondStep = () => {
  return <div>SecondStep</div>;
};

export default SecondStep;
